import { createActions, createState, createReducer } from 'reduxsauce-crud'

export const OverviewRedux = createActions({},
  {
    prefix: 'OVERVIEW_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = OverviewRedux
export const OverviewTypes = Types
export default Creators

export const INITIAL_STATE = createState({}, {
  get: true,
})

export const reducer = createReducer(INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/OverviewRedux.js